<template>

	<v-container
		fluid
    v-if="!authed"
	>
  
		<v-row>
			<v-col cols="3">
			</v-col>
			<v-col cols="6">
          <v-text-field
            label=""
            placeholder="Ingrese la contraseña"
            solo
            v-model="password"
          @keyup.enter="doAuth()"


          ></v-text-field>

			</v-col>
		</v-row>
    
		<v-row>
			<v-col cols="3">
			</v-col>
			<v-col cols="6">
        <v-btn
          depressed
          color="primary"
          @click="doAuth()"
        >
          Ingresar
        </v-btn>
			</v-col>
		</v-row>
    
	</v-container>

	<v-container
		class="fill-height"
		fluid
    v-else
	>
  <a href="/fichas" style="position: fixed;right:5px;top:0">Fichas</a>

		<v-row>
			<v-col cols="12">

				<v-row
					align="start"
					justify="center"
					class=""
				>

				<v-card
					class="pa-1"
					flat
				>
						<ul style="list-style:none;padding-left:0px" id="example-1">
							<li v-for="item in items1" :key="item.file">
								<drag class="drag"
									:image="require('../assets/planetasdrag/' + item.file + '.png')"
									:transfer-data="item"
									:image-x-offset="offset"
									:image-y-offset="offset"
                  style="pointer-events: mask;"
								>

									<v-img
                  style="width:110px"
									:src="require('../assets/planetasdrag/' + item.file + '.png')"
									class="msy-3"
									/>
								</drag>
							</li>
						</ul>
					</v-card>

					<v-card
						class="px-2"
						flat
					>

						<drop
							class="drop"
							@drop="handleDrop"
						>


							<v-img
								:src="require('../assets/mandala.png')"
								class="my-3"
								width="500"
							/>

							<div  v-for="item in droppedImages" :key="item.file">

							
								<drag class="drag"
									:image="require('../assets/planetasdrag/' + item.file + '.png')"
									:transfer-data="item"
									:image-x-offset="55"
									:image-y-offset="55"
                  style="pointer-events: mask;"
                   :hide-image-html="false"
v-on:dblclick.native="removePlanet(item)"

								>

									<v-img
										:src="require('../assets/planetasdrag/' + item.file + '.png')"
										class="may-3"
										:style="'width:110px;position:fixed;top: '+item.y + 'px;left: '+item.x + 'px'"



										/>
								</drag>
							</div>
						</drop>

					</v-card>
					<v-card
						class="pa-2"
						flat
						
					>
						<ul style="list-style:none;padding-left:0px" id="example-2">
							<li v-for="item in items2" :key="item.file">
								<drag class="drag"
									:image="require('../assets/planetasdrag/' + item.file + '.png')"
									:transfer-data="item"
									:image-x-offset="offset"
									:image-y-offset="offset"

                  style="pointer-events: mask;"
								>

									<v-img
									:src="require('../assets/planetasdrag/' + item.file + '.png')"
									class="msy-3"
                  style="width:110px"
									/>
								</drag>
							</li>
						</ul>
					</v-card>
				</v-row>
			</v-col>
		</v-row>
    
	</v-container>
</template>

<script>

import { Drag, Drop } from 'vue-drag-drop';
import Vue from 'vue'

export default {
	name: 'Home',
	mounted() {
		if(window.devicePixelRatio == 1){
			this.offset = 55;
		}else{
			if(window.devicePixelRatio == 1.25){
				this.offset = 85;
			}
		}
		
		if (localStorage.password) {
			this.$nextTick(() => {
				if(this.validateUserPassword(localStorage.password)){
					this.authed = true;
				}
			});
		}
	},
	methods: {
		validateUserPassword(password) {
			const encodedPassword = btoa(password);
			const user = this.users.find(u => u.password === encodedPassword);

			if (!user) {
				return false;
			}
			if(user.expires && new Date(user.expires) < new Date()) {
				console.log('expired!');
				return false;
			}

			return true;
		},
		removePlanet(data) {
			for (var x=0; x < this.droppedImages.length; x++) {
				if (this.droppedImages[x].file === data.file) {
					Vue.delete(this.droppedImages, x)
					break;
				}
			}
    	},

		doAuth() { 
			if(this.password == ""){
				return;
			}

			if(this.validateUserPassword(this.password)){
				localStorage.password = this.password;
				this.password = "";
				this.authed = true;
			}else{
				this.authed = false;
				this.password = "";
				localStorage.password = "";
				alert("Contraseña incorrecta ó acceso expirado");
			}
		},
		handleDrop(data, evt) {
			let i = -1;
			for (var x=0; x < this.droppedImages.length; x++) {
				if (this.droppedImages[x].file === data.file) {
					i = x;
					break;
				}
			}

			if(i == -1){
				Vue.set(data, 'x', evt.clientX - 55);
				Vue.set(data, 'y', evt.clientY - 55);
				this.droppedImages.push(data);
			}else{
				let obj = this.droppedImages[i];
				obj.x = evt.clientX - 55;
				obj.y = evt.clientY - 55;
				Vue.set(this.droppedImages, i, obj);
			}
				
		}
	},
	data: function() {
		return {
			users: [
				{
					password: 'Y2VjaTEyMzQ=',
					expires: '', // 2025-02-01T00:00:00Z
					comment: ''
				},{
					password: 'ZXF1MXAw',
					expires: '',
					comment: 'equ1p0'
				},{
					password: 'cHJpc2NpbDQ=',
					expires: '',
					comment: 'priscil4'
				},{
					password: 'Z2FsZWdpZ0BnbWFpbC5jb20=',
					expires: '',
					comment: 'galegig@gmail.com Gabriela Guantay'
				},{
					password: 'MjAyNWZvcm1hY2lvbg==',
					expires: '2026-12-31T23:59:59Z',
				},{
					password: 'c29maWFsaW9uZXR0aUBnbWFpbC5jb20=',
					expires: '2025-02-28T23:59:00Z',
					comment: 'sofialionetti@gmail.com'
				},{
					password: 'cmFtaXJlemRob3ZhbGVudGluYUBnbWFpbC5jb20=',
					expires: '2025-02-28T23:59:00Z',
					comment: 'Valentina Ramirez'
				},
				

				{
					password: 'ZXJpa2Fib3Jkb3lAZ21haWwuY29t',
					expires: '',
					comment: 'erikabordoy@gmail.com'
				},
				




				// vencidos
				{
					password: 'ZXZhLnBsYW5hc0B5YWhvby5jb20=',
					expires: '2025-02-20T00:00:00Z',
					comment: 'Eva Planas'
				},{
					password: 'aG9sYWhvbGFwcm9iYW5kbw==',
					expires: '2025-01-21T23:59:00Z',
					comment: ''
				},{
					password: 'Z2lrYTA0QHlhaG9vLmNvbS5hcg==',
					expires: '2025-02-20T00:00:00Z',
					comment: 'Gisela Larracochea gika04@yahoo.com.ar'
				},{
					password: 'b3JldDhAbXNuLmNvbQ==',
					expires: '2025-02-20T00:00:00Z',
					comment: 'oret8@msn.com'
				},{
					password: 'ZXJpa2Fib3Jkb3lAZ21haWwuY29t',
					expires: '2025-02-20T00:00:00Z',
					comment: 'erikabordoy@gmail.com'
				},{
					password: 'bWljaGlkYW1vbnRlQGhvdG1haWwuY29t',
					expires: '2025-08-31T23:59:00Z',
					comment: 'michidamonte@hotmail.com', 
				},{
					password: 'c2VsdmFjb25jaWVuY2lhbmltYWxAZ21haWwuY29t',
					expires: '2025-10-08T23:59:00Z',
					comment: 'Selva Gonzalez selvaconciencianimal@gmail.com', 
				},{
					password: 'ZG9jZWx1YXNjcmlhbnphQGdtYWlsLmNvbQ==',
					expires: '2025-02-20T00:00:00Z',
					comment: 'doceluascrianza@gmail.com'
				},{
					password: 'bWFiZWxldmF6cXVlekBob3RtYWlsLmNvbQ==',
					expires: '2025-02-20T00:00:00Z',
					comment: 'mabelevazquez@hotmail.com'
				},{
					password: 'bWZydWJpbm9AeWFob28uY29tLmFy',
					expires: '2025-02-20T00:00:00Z',
					comment: 'mfrubino@yahoo.com.ar'
				},{
					password: 'bWNyYXBhbGlub0BnbWFpbC5jb20=',
					expires: '2025-02-20T00:00:00Z',
					comment: 'mcrapalino@gmail.com'
				},{
					password: 'dmVyb25pY2Eub3JlbGxhbmEyMDExQGdtYWlsLmNvbQ==',
					expires: '2025-02-20T00:00:00Z',
					comment: 'veronica.orellana2011@gmail.com'
				},{
					password: 'dmlyYWxhbml6NTRAZ21haWwuY29t',
					expires: '2025-11-18T23:59:59Z',
					comment: 'Daniela Virginia Alaniz viralaniz54@gmail.com'
				}
			],
			offset: 125,
			loading: true,
			password: "",
			authed: false,
			droppedImages: [],

			items1: [
				{ 
					file: "1",
				},
				{ 
					file: "2",
				},
				{ 
					file: "3",
				},
				{ 
					file: "4",
				},
				{ 
					file: "5",
				}
			],
			items2: [
				{ 
					file: "6",
				},
				{ 
					file: "7",
				},
				{ 
					file: "8",
				},
				{ 
					file: "9",
				},
				{ 
					file: "10",
				}
			],
		};
	},
	components: { Drag, Drop }
}
</script>
